import { /* useId, */ useState, useMemo } from 'react';
import { selectFirstBusyTask, selectServerLastCommunication, useAppSelector, selectSharedDataBundleId } from '@/store';
import { getBundleFilterOptionsApi } from '@/api/bundle/getBundleFilterOptions';
import {
  ConnectionIndicator,
  FilterWithoutFillIcon,
  ProgressSpinner,
  /* InputSwitch,
  InputSwitchChangeEvent, */
} from '@repo/atomic-components';
import { useBundleFilterOptions /* , useAnnotationLabelsContext */ } from '../hooks';
import { BundleLabel } from './BundleLabel';
import { FilterDialog } from './FilterDialog';
import { SearchTextControl } from './SearchTextControl';
import { BundleUndoRedoButtons } from './BundleUndoRedoButtons';
import { BundleDownloadButton } from './BundleDownloadButton';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { InternetConnectionBanner } from '@/ui/components/InternetConnectionBanner';
import { OutlineButton } from '@/ui/components/OutlineButton';

export const ActionsPanel = () => {
  useOnlineStatus();
  /* const { showFilteredLabels, setShowFilteredLabels } = useAnnotationLabelsContext();
  const filteredLabelsId = useId(); */
  const serverLastCommunication = useAppSelector(selectServerLastCommunication);
  const activeBusyTask = useAppSelector(selectFirstBusyTask);
  const [isFilterDialogVisible, setIsFilterDialogVisible] = useState<boolean>(false);
  const bundleId = useAppSelector(selectSharedDataBundleId);
  const selectBundleFilterOptions = useMemo(
    () => getBundleFilterOptionsApi.endpoints.getBundleFilterOptions.select({ bundleId: bundleId || '' }),
    [bundleId],
  );
  const { isLoading: isBundleFilterOptionsLoading } = useAppSelector(selectBundleFilterOptions);

  const { selectedFilters } = useBundleFilterOptions();

  return (
    <div className="flex w-full flex-col">
      <div className="bg-fletchers-white border-fletchers-gray-110 flex h-full w-full flex-row items-center justify-center gap-2 border-b px-6 py-[8px]">
        <BundleLabel />
        <div className="relative mx-[8px] flex items-center">
          {/* Phantom reference sized to a wide Autosaved timestamp so the slot's
              width is pinned to whatever the ConnectionIndicator would occupy,
              without depending on the current busy description. */}
          <div className="pointer-events-none invisible flex items-center gap-1">
            <span className="h-4 w-4" />
            <span className="text-[12px] font-normal whitespace-nowrap">Autosaved: 00:00 00 Xxx 0000</span>
          </div>
          <div className="absolute inset-0 flex items-center">
            {activeBusyTask ? (
              <div className="flex items-center gap-1 overflow-hidden">
                <ProgressSpinner
                  strokeWidth="4"
                  style={{ width: 16, height: 16 }}
                  className="[&_.p-progress-spinner-circle]:!stroke-fletchers-green-500 !h-4 !w-4 shrink-0"
                />
                <span className="text-fletchers-gray-200 overflow-hidden text-[12px] font-normal text-ellipsis whitespace-nowrap">
                  {activeBusyTask.description}
                </span>
              </div>
            ) : (
              <ConnectionIndicator lastCommunication={serverLastCommunication} />
            )}
          </div>
        </div>
        <BundleUndoRedoButtons />
        <BundleDownloadButton />

        <div className="w-4xs ml-auto">
          <SearchTextControl />
        </div>

        <div className="relative">
          <OutlineButton
            className="whitespace-nowrap"
            loading={isBundleFilterOptionsLoading}
            disabled={isBundleFilterOptionsLoading}
            onClick={() => setIsFilterDialogVisible(true)}
          >
            <FilterWithoutFillIcon />
            <span className="ml-2">Filters</span>
          </OutlineButton>
          {!!selectedFilters && (
            <span className="absolute -top-[4px] -right-[4px] h-[8px] w-[8px] rounded-full bg-amber-500" />
          )}
          {isFilterDialogVisible && <FilterDialog onHide={setIsFilterDialogVisible} />}
        </div>

        {/* <label htmlFor={filteredLabelsId} className="text-sm whitespace-nowrap">
          Filtered labels
        </label>
        <InputSwitch
          inputId={filteredLabelsId}
          checked={showFilteredLabels}
          onChange={(e: InputSwitchChangeEvent) => setShowFilteredLabels(e.value)}
        /> */}
      </div>
      <InternetConnectionBanner />
    </div>
  );
};
